// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"22548e24","884":"2f7e2135"}[chunkId] + ".chunk.js";
};